/* ==========================================================================
   Coffao — Annuaire coffee shops
   Filtrage client, synchronisation d'URL, carte Leaflet chargée à la demande.
   Aucune dépendance hors Leaflet (chargé uniquement si l'utilisateur ouvre la carte).
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-cs-directory]');
  if (!root) return;

  var LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  var LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';

  var listEl = root.querySelector('[data-cs-list]');
  var emptyEl = root.querySelector('[data-cs-empty]');
  var mapEl = root.querySelector('[data-cs-map]');
  var countEl = root.querySelector('[data-cs-count]');
  var sheetCountEl = root.querySelector('[data-cs-sheet-count]');
  var filterCountEl = root.querySelector('[data-cs-filter-count]');
  var clearEl = root.querySelector('[data-cs-clear]');
  var searchEl = root.querySelector('[data-cs-search]');
  var sheetEl = root.querySelector('[data-cs-sheet]');
  var filterBtn = root.querySelector('[data-cs-filter-open]');

  // Sur une page arrondissement, le filtre quartier est verrouillé : la page
  // ne doit jamais afficher d'adresse hors périmètre.
  var lockedArr = root.getAttribute('data-cs-lock-arr') || '';
  var state = { q: '', arr: lockedArr ? [lockedArr] : [], m: [], s: [], view: 'list' };
  var map = null;
  var markerLayer = null;
  var leafletLoading = null;

  /* ---------- chargement des fiches au-delà de la 50e ---------------------
     blog.articles est plafonné à 50 en Liquid. Les suivantes sont récupérées
     via la vue alternative ?view=cs-data, qui rend les mêmes cartes.        */
  function loadRemaining() {
    var next = root.getAttribute('data-cs-next-page');
    if (!next) return Promise.resolve();
    return fetch(next, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var cards = tmp.querySelectorAll('[data-cs-card]');
        for (var i = 0; i < cards.length; i++) listEl.appendChild(cards[i]);
        var more = tmp.querySelector('[data-cs-next-page]');
        root.setAttribute('data-cs-next-page', more ? more.getAttribute('data-cs-next-page') : '');
        if (more && more.getAttribute('data-cs-next-page')) return loadRemaining();
      })
      .catch(function () { /* la liste reste utilisable avec les 50 premières */ });
  }

  /* ---------- filtrage ---------- */
  function cards() {
    return listEl ? listEl.querySelectorAll('[data-cs-card]') : [];
  }

  function listValues(card, attr) {
    var raw = card.getAttribute(attr) || '';
    return raw.split(',').filter(Boolean);
  }

  function matches(card) {
    if (state.q) {
      var hay = (card.getAttribute('data-cs-haystack') || '').toLowerCase();
      if (hay.indexOf(state.q.toLowerCase()) === -1) return false;
    }
    if (state.arr.length && state.arr.indexOf(card.getAttribute('data-cs-arr')) === -1) return false;
    var m = listValues(card, 'data-cs-methodes');
    for (var i = 0; i < state.m.length; i++) if (m.indexOf(state.m[i]) === -1) return false;
    var s = listValues(card, 'data-cs-services');
    for (var j = 0; j < state.s.length; j++) if (s.indexOf(state.s[j]) === -1) return false;
    return true;
  }

  function activeCount() {
    return state.arr.length + state.m.length + state.s.length;
  }

  function render() {
    var all = cards();
    var visible = [];
    for (var i = 0; i < all.length; i++) {
      var ok = matches(all[i]);
      all[i].hidden = !ok;
      if (ok) visible.push(all[i]);
    }
    var n = visible.length;
    if (countEl) countEl.textContent = n;
    if (sheetCountEl) sheetCountEl.textContent = n;
    var nf = activeCount();
    if (filterCountEl) {
      filterCountEl.textContent = nf ? nf : '';
      filterCountEl.setAttribute('data-z', nf);
    }
    if (clearEl) clearEl.classList.toggle('cs-hidden', !(nf || state.q));
    if (emptyEl) emptyEl.classList.toggle('cs-hidden', n > 0 || state.view === 'map');
    if (listEl) listEl.classList.toggle('cs-hidden', n === 0 || state.view === 'map');
    if (mapEl) mapEl.classList.toggle('cs-hidden', state.view !== 'map');
    if (state.view === 'map') drawMap(visible);
    syncUrl();
  }

  /* ---------- chips (barre + panneau, synchronisés) ---------- */
  function syncChips() {
    var chips = root.querySelectorAll('[data-cs-chip]');
    for (var i = 0; i < chips.length; i++) {
      var k = chips[i].getAttribute('data-cs-key');
      var v = chips[i].getAttribute('data-cs-value');
      chips[i].setAttribute('aria-pressed', state[k].indexOf(v) !== -1);
    }
  }

  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-cs-chip]');
    if (!chip) return;
    var k = chip.getAttribute('data-cs-key');
    var v = chip.getAttribute('data-cs-value');
    var i = state[k].indexOf(v);
    if (i === -1) state[k].push(v); else state[k].splice(i, 1);
    syncChips();
    render();
  });

  /* ---------- recherche ---------- */
  if (searchEl) {
    var t;
    searchEl.addEventListener('input', function (e) {
      clearTimeout(t);
      var val = e.target.value;
      t = setTimeout(function () { state.q = val; render(); }, 150);
    });
  }

  /* ---------- reset ---------- */
  function resetAll() {
    state.q = ''; state.arr = lockedArr ? [lockedArr] : []; state.m = []; state.s = [];
    if (searchEl) searchEl.value = '';
    syncChips();
    render();
  }
  var resets = root.querySelectorAll('[data-cs-reset]');
  for (var r = 0; r < resets.length; r++) resets[r].addEventListener('click', resetAll);

  /* ---------- panneau mobile ---------- */
  function openSheet() {
    if (!sheetEl) return;
    sheetEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var first = sheetEl.querySelector('[data-cs-chip]');
    if (first) first.focus();
  }
  function closeSheet() {
    if (!sheetEl) return;
    sheetEl.classList.remove('is-open');
    document.body.style.overflow = '';
    if (filterBtn) filterBtn.focus();
  }
  if (filterBtn) filterBtn.addEventListener('click', openSheet);
  if (sheetEl) {
    sheetEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-cs-sheet-close]')) closeSheet();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheetEl && sheetEl.classList.contains('is-open')) closeSheet();
  });

  /* ---------- bascule liste / carte ---------- */
  var viewBtns = root.querySelectorAll('[data-cs-view]');
  for (var v = 0; v < viewBtns.length; v++) {
    viewBtns[v].addEventListener('click', function (e) {
      state.view = e.currentTarget.getAttribute('data-cs-view');
      for (var k = 0; k < viewBtns.length; k++) {
        viewBtns[k].setAttribute('aria-pressed', viewBtns[k] === e.currentTarget);
      }
      if (state.view === 'map') ensureLeaflet().then(render); else render();
    });
  }

  /* ---------- carte ---------- */
  function ensureLeaflet() {
    if (window.L) return Promise.resolve();
    if (leafletLoading) return leafletLoading;
    leafletLoading = new Promise(function (resolve) {
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = LEAFLET_CSS;
      document.head.appendChild(css);
      var js = document.createElement('script');
      js.src = LEAFLET_JS;
      js.onload = resolve;
      js.onerror = resolve;
      document.head.appendChild(js);
    });
    return leafletLoading;
  }

  function drawMap(visible) {
    if (!window.L || !mapEl) return;
    if (!map) {
      map = window.L.map(mapEl, { scrollWheelZoom: false }).setView([48.8566, 2.3522], 12);
      window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; contributeurs OpenStreetMap'
      }).addTo(map);
      markerLayer = window.L.layerGroup().addTo(map);
    }
    markerLayer.clearLayers();
    var bounds = [];
    for (var i = 0; i < visible.length; i++) {
      var lat = parseFloat(visible[i].getAttribute('data-cs-lat'));
      var lng = parseFloat(visible[i].getAttribute('data-cs-lng'));
      if (isNaN(lat) || isNaN(lng)) continue;
      var name = visible[i].getAttribute('data-cs-name') || '';
      var url = visible[i].getAttribute('data-cs-url') || '#';
      var where = visible[i].getAttribute('data-cs-where') || '';
      window.L.marker([lat, lng])
        .bindPopup('<strong>' + name + '</strong><br>' + where + '<br><a href="' + url + '">Voir la fiche</a>')
        .addTo(markerLayer);
      bounds.push([lat, lng]);
    }
    if (bounds.length) map.fitBounds(bounds, { padding: [30, 30], maxZoom: 15 });
    setTimeout(function () { map.invalidateSize(); }, 60);
  }

  /* ---------- compteurs des tampons arrondissement ----------
     Calculés depuis les cartes réellement présentes : plus aucun risque
     de voir un compteur diverger du listing, comme c'était le cas avant. */
  function fillStampCounts() {
    var slots = root.querySelectorAll('[data-cs-stamp-count]');
    if (!slots.length) return;
    var tally = {};
    var all = cards();
    for (var i = 0; i < all.length; i++) {
      var a = all[i].getAttribute('data-cs-arr');
      if (a) tally[a] = (tally[a] || 0) + 1;
    }
    for (var k = 0; k < slots.length; k++) {
      var label = slots[k].getAttribute('data-cs-stamp-count');
      var n = tally[label] || 0;
      slots[k].textContent = n + (n > 1 ? ' adresses' : ' adresse');
    }
  }

  /* ---------- synchronisation d'URL ---------- */
  function syncUrl() {
    if (!window.history || !window.history.replaceState) return;
    var p = new URLSearchParams();
    if (state.q) p.set('q', state.q);
    if (state.arr.length && !lockedArr) p.set('arr', state.arr.join(','));
    if (state.m.length) p.set('m', state.m.join(','));
    if (state.s.length) p.set('s', state.s.join(','));
    var qs = p.toString();
    history.replaceState(null, '', qs ? location.pathname + '?' + qs : location.pathname);
  }

  function readUrl() {
    var p = new URLSearchParams(location.search);
    state.q = p.get('q') || '';
    state.arr = (p.get('arr') || '').split(',').filter(Boolean);
    state.m = (p.get('m') || '').split(',').filter(Boolean);
    state.s = (p.get('s') || '').split(',').filter(Boolean);
    if (lockedArr) state.arr = [lockedArr];
    if (searchEl) searchEl.value = state.q;
    syncChips();
  }

  /* ---------- init ---------- */
  readUrl();
  render();
  fillStampCounts();
  loadRemaining().then(function () { render(); fillStampCounts(); });
})();
